"use client"
import { useEffect } from "react";
import { usePathname } from 'next/navigation';
import { AnalyticsEventName } from '@shopify/hydrogen-react';
import { useShopifyAnalytics } from "@lib/Shopify/hydrogen/use-analytics";

export default function ShopifyAnalyticsPageView() {
    const { sendPageView } = useShopifyAnalytics();
    const pathname = usePathname();

    useEffect(() => {
        sendPageView(AnalyticsEventName.PAGE_VIEW);
    }, [sendPageView, pathname]);

    return null;
}
